import { Navigate, RouterProvider, createBrowserRouter } from 'react-router-dom'
import { Center, Paper, Stack, Text, Title } from '@mantine/core'
import { useAdminAuth } from './auth/AdminAuthProvider'
import SignIn from './routes/SignIn'
import NotAuthorised from './routes/NotAuthorised'
import Home from './routes/Home'
import Calendar from './routes/Calendar'
import Status from './routes/Status'
import SeriesPage from './routes/SeriesPage'
import TracksPage from './routes/TracksPage'
import VendorRis from './routes/VendorRis'
import VendorTsl from './routes/VendorTsl'
import EventDetail from './routes/EventDetail'

/**
 * A data router rather than <BrowserRouter>, because useBlocker — which is what
 * stops a navigation away from unsaved edits — only exists on one. Built once
 * at module scope: rebuilding it on every render would remount the whole tree
 * and lose exactly the state the guard is protecting.
 */
const router = createBrowserRouter([
  {
    element: <Home />,
    children: [
      { index: true, element: <Calendar /> },
      { path: 'status', element: <Status /> },
      { path: 'series', element: <SeriesPage /> },
      { path: 'tracks', element: <TracksPage /> },
      { path: 'vendors/ris', element: <VendorRis /> },
      { path: 'vendors/tsl', element: <VendorTsl /> },
      { path: 'events/:eventId', element: <EventDetail /> },
      { path: '*', element: <Navigate to="/" replace /> },
    ],
  },
])

export default function App() {
  const { state } = useAdminAuth()

  if (state.status === 'loading') {
    return (
      <Center mih="100vh">
        <Text c="dimmed">Checking access…</Text>
      </Center>
    )
  }
  if (state.status === 'signed-out') return <SignIn />
  if (state.status === 'not-authorised') return <NotAuthorised />
  if (state.status === 'error') {
    return (
      <Center mih="100vh" p="md">
        <Paper withBorder p="xl" w={420} maw="100%">
          <Stack gap="xs">
            <Title order={1} size="h3">
              Something went wrong
            </Title>
            <Text c="dimmed" size="sm">
              {state.message}
            </Text>
          </Stack>
        </Paper>
      </Center>
    )
  }

  return <RouterProvider router={router} />
}
